module.exports = __webpack_public_path__ + "static/media/dashboard-traccio-desktop.0a1faf78.png";